import { _get, _post, _delete } from "../../../http";

//Endpoints para la gestión de Mis favoritos

export const getProductosFavoritos = () => _get("/market-place/favoritos");

export const postProductoFavorito = (body) => _post("/market-place/favoritos", body);

export const deleteProductoFavorito = (productoFavoritoId) => _delete(`/market-place/favoritos/${productoFavoritoId}`);
